export default class ComponentTradingHours {
    constructor(container, options) {
        this.container = document.querySelector(container);
        this.options = Object.assign({
            endpoint: '//content.teeg.localhost:5000/api/v1/data/trading-hours/1709',
            days: [
                'Sunday',
                'Monday',
                'Tuesday',
                'Wednesday',
                'Thursday',
                'Friday',
                'Saturday'
            ],
            months: [
                'January',
                'February',
                'March',
                'April',
                'May',
                'June',
                'July',
                'August',
                'September',
                'October',
                'November',
                'December'
            ]
        }, options);
        
        this.tradingHours = [];
        
        this.setEvents();
    }

    setEvents() {
        window.addEventListener('DOMContentLoaded', () => {
            fetch(this.options.endpoint)
                .then(response => response.json())
                .then(tradingHours =>  {
                    this.processTradingHours(tradingHours);
                });
        });
    }
    
    processTradingHours(tradingHours) {
        let defaultTradingHours = [];
        let overrideTradingHours = [];
        let closedTradingHours = [];
        let next7Days = [];
        
        
        for (let tradingHour of tradingHours) {
            if(tradingHour.startDate === '0001-01-01' && tradingHour.endDate === '0001-01-01') {
                defaultTradingHours.push(tradingHour);
            }
            else if(tradingHour.status === 'open') {
                overrideTradingHours.push(tradingHour);
            }
            else if(tradingHour.status === 'closed') {
                closedTradingHours.push(tradingHour);
            }
        }
        
        const startDay = 'Monday';
        const date = new Date();
        
        for(var i = 0; i < 7; i++) {
            let year = date.getFullYear();
            let month = (date.getMonth() + 1 < 10) ? '0' + (date.getMonth() + 1) : (date.getMonth()+1).toString();
            let day = (date.getDate() < 10) ? '0' + date.getDate() : date.getDate().toString();
            let dateFormatted = `${year}-${month}-${day}`;
            let currentDayName = this.options.days[date.getDay()];
            let monthName = this.options.months[date.getMonth()];
            let status = 'open';
            
            let openTime = '';
            let closeTime = '';

            let trading = defaultTradingHours.filter(x => x.days.indexOf(currentDayName) > -1);
            if(trading.length > 0) {
                openTime = trading[0].timeStart;
                closeTime = trading[0].timeEnd;
            }

            let overrideTrading = overrideTradingHours.filter(x =>
                dateFormatted >= x.startDate
                && dateFormatted <= x.endDate
                && x.days.indexOf(currentDayName) > -1);
            if(overrideTrading.length > 0) {
                openTime = overrideTrading[0].timeStart;
                closeTime = overrideTrading[0].timeEnd;
            }
            
            let closed = closedTradingHours.filter(
                x => dateFormatted >= x.startDate
                && dateFormatted <= x.endDate
            );
            if(closed.length > 0) {
                status = 'closed';
            }
            
            next7Days.push({
                dayName: currentDayName,
                dayNameShort: currentDayName.substring(0, 3),
                monthName: monthName,
                monthNameShort: monthName.substring(0, 3),
                dateFormatted,
                year,
                month,
                date: day,
                openTime,
                closeTime,
                status
            });

            date.setDate(date.getDate() + 1);
        }
        
        this.tradingHours = next7Days;
        
        this.render();
    }
    
    render() {
        let wrapper = document.createElement('div');
        wrapper.classList.add('trading-hours');
        
        let index = 0;
        for(var tradingHour of this.tradingHours) {
            const openTime = this.formatTime(tradingHour.openTime);
            const closeTime = this.formatTime(tradingHour.closeTime);
            
            let titleColumn = document.createElement('div');
            titleColumn.classList.add('date');

            if(index === 0) {
                titleColumn.innerHTML = 'Today';
            }
            else if(index === 1) {
                titleColumn.innerHTML = 'Tomorrow';
            }
            else {
                titleColumn.innerHTML = `${tradingHour.dayNameShort} ${tradingHour.date} ${tradingHour.monthNameShort}`;    
            }
            

            let valueColumn = document.createElement('div');
            valueColumn.classList.add('opening-hours');
            if(tradingHour.status == 'closed') {
                valueColumn.innerHTML = 'closed';
            }
            else {
                valueColumn.innerHTML = `${openTime} - ${closeTime}`;
            }
            
            let row = document.createElement('div');
            row.classList.add('trading-row');
            
            
            row.appendChild(titleColumn);
            row.appendChild(valueColumn);

            wrapper.appendChild(row);
            index++;
        }
        this.container.innerHTML = '';
        this.container.appendChild(wrapper);
    }
    
    formatTime(time) {
        const parts = time.split(':');
        
        const hour = parseInt(parts[0], 10);
        let minute = 0;
        if(parts.length >= 2) {
            minute = parseInt(parts[1], 10)
        }

        let formattedHour = '12';
        let formattedMinute = '';
        let suffix = 'am';
        
        if(hour === 0) {
            formattedHour = '12';
        }
        else if(hour >= 12) {
            suffix = 'pm';
            
            if(hour > 12) {
                formattedHour = (hour - 12).toString();
            }
        }
        else {
            formattedHour = hour.toString();
        }
        
        if(minute >= 0) {
            formattedMinute = minute < 10 ? '0' + minute : minute.toString();
        }

        return `${formattedHour}:${formattedMinute} ${suffix}`;
    }
    
    
}